import { pdsTv } from '@nestle-npus-nbm/pds-ui';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';

import { ButtonLink, Link } from 'src/components/Link';
import { getAnchorTarget } from 'src/utils/url';

const nerdMenuLinkStyles = pdsTv({
  base: ['pds-no-underline', 'pds-text-body-md'],
  variants: {
    type: {
      regular: 'pds-inline-flex pds-font-normal',
      bold: 'pds-font-bold',
      button: 'pds-m-0 pds-flex pds-w-fit pds-min-w-[104px] pds-rounded-pill pds-py-4',
    },
  },
});

export const BoldLink: React.FC<{
  link: NerdMenuElement;
  className?: string;
}> = ({ link, className }) => {
  const styles = nerdMenuLinkStyles({ type: 'bold', className });

  return (
    <Link
      partiallyActive
      theme="dark"
      analytics={false}
      to={link.link.url}
      target={getAnchorTarget(link.link.url)}
      className={styles}
      onClick={() => {
        sendIt({
          event: 'nav_click',
          eventParams: {
            nav_item: link.title,
            nav_type: 'footer',
          },
        });
      }}
    >
      {link.title}
    </Link>
  );
};

export const OutlinedLink: React.FC<{
  link: NerdMenuElement;
  className?: string;
}> = ({ link, className }) => {
  const styles = nerdMenuLinkStyles({ type: 'button', className: ['pds-py-3', className] });

  return (
    <ButtonLink
      to={link.link.url}
      partiallyActive
      buttonStyle="outlined"
      buttonColor="inverse"
      analytics={false}
      target={getAnchorTarget(link.link.url)}
      className={styles}
      onClick={() => {
        sendIt({
          event: 'nav_click',
          eventParams: {
            nav_item: link.title,
            nav_type: 'footer',
          },
        });
      }}
    >
      {link.title}
    </ButtonLink>
  );
};

export const FilledLink: React.FC<{
  link: NerdMenuElement;
  className?: string;
}> = ({ link, className }) => {
  const styles = nerdMenuLinkStyles({ type: 'button', className });

  return (
    <ButtonLink
      to={link.link.url}
      buttonStyle="solid"
      buttonColor="inverse"
      partiallyActive
      analytics={false}
      target={getAnchorTarget(link.link.url)}
      className={styles}
      onClick={() => {
        sendIt({
          event: 'nav_click',
          eventParams: {
            nav_item: link.title,
            nav_type: 'footer',
          },
        });
      }}
    >
      {link.title}
    </ButtonLink>
  );
};

export const RegularLink: React.FC<{
  link: NerdMenuElement;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
}> = ({ link, onClick, children, className }) => {
  const styles = nerdMenuLinkStyles({ type: 'regular', className });

  return (
    <Link
      partiallyActive
      analytics={false}
      to={link.link.url}
      target={getAnchorTarget(link.link.url)}
      theme="dark"
      className={styles}
      onClick={() => {
        sendIt({
          event: 'nav_click',
          eventParams: {
            nav_item: link.title,
            nav_type: 'footer',
          },
        });
        if (onClick) onClick();
      }}
    >
      {link.title}
      {children}
    </Link>
  );
};
